import React from 'react';
import { Mail as MailIcon, Room as RoomIcon, Person as PersonIcon, Warning as WarningIcon, 
  AdminPanelSettings as AdminPanelSettingsIcon, BarChart, Insights, Cloud as CloudIcon, Flag } from '@mui/icons-material';
 import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
 import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
interface InfoCardProps {
  classification: string;
  count: number | string;
}

const iconMap: Record<string, React.ReactNode> = {
  SharedMailbox: <MailIcon fontSize="inherit" />,
  RoomMailbox: <RoomIcon fontSize="inherit" />,
  UserMailbox: <PersonIcon fontSize="inherit" />,
  OutOfScope: <WarningIcon fontSize="inherit" />,
  ADMAccount: <AdminPanelSettingsIcon fontSize="inherit" />,
  ServiceMailbox: <CloudIcon fontSize="inherit" />,
  TotalEmails: <BarChart fontSize="inherit" />,
  scopeChangeStatus: <Flag fontSize="inherit" />, 
  changePercentage: <Insights fontSize="inherit" />,
  Threshold: <DataThresholdingIcon fontSize="inherit" />,
  total: <AssignmentTurnedInIcon fontSize="inherit" />
};

const InfoCard: React.FC<InfoCardProps> = ({ classification, count }) => {
  return (
    <div className="p-4 m-2 border rounded-lg shadow-lg flex flex-col items-center justify-center">
      <div className="text-4xl mb-2">
        {iconMap[classification] || <WarningIcon fontSize="inherit" />}
      </div>
      <h3 className="text-lg font-bold">{classification}</h3>
      <p className="text-xl font-semibold">{ Number(count) ? Number(count).toFixed(0) : count}</p> 
    </div>
  );
};

export default InfoCard;
